/** Enum de acciones sobre una orden de servicio: Play, Pausa, Reinicio, Detener y Entregar. */
export enum AccionServicio {
  Play = 1,
  Pausa = 2,
  Reinicio = 3,
  Detener = 4,
  Entregar = 5,
}